import Accordion from './Accordion';

const create_accordions = (context = document) => {
  return [...context.querySelectorAll('.js-accordion-container')].map(
    accordionElement =>
      new Accordion({
        container: accordionElement,
        tab_selector: '.js-accordion-control',
        tab_content_selector: '.js-accordion-target',
      }),
  );
};

const create_widgets = (context = document) => {
  return [...create_accordions(context)];
};

export { create_widgets, create_accordions };



// WEBPACK FOOTER //
// ./src/js/widgets/create_widgets.js